import { isHttpImageUrl } from '@/lib/tokenImage'

export default function ColonyAvatar({
  wallet,
  image,
  size = 'md',
  anonymous = false,
}: {
  wallet?: string
  image?: string
  size?: 'sm' | 'md' | 'lg' | 'full'
  anonymous?: boolean
}) {
  const label = anonymous ? 'PP' : ((wallet || 'PP').replace(/^0x/i, '').slice(0, 2).toUpperCase() || 'PP')
  const isFull = size === 'full'
  const sizeClass = isFull
    ? 'absolute inset-0 h-full w-full text-lg'
    : size === 'lg'
      ? 'h-16 w-16 text-lg'
      : size === 'sm'
        ? 'h-8 w-8 text-[10px]'
        : 'h-12 w-12 text-sm'
  const shapeClass = isFull ? 'rounded-xl' : 'rounded-full'
  const photo = image && isHttpImageUrl(image) ? image : ''

  if (photo) {
    return (
      <img
        src={photo}
        alt=""
        className={`${sizeClass} shrink-0 ${shapeClass} border border-lime-400/20 object-cover`}
      />
    )
  }

  return (
    <div className={`flex ${sizeClass} shrink-0 items-center justify-center ${shapeClass} border border-lime-400/20 bg-lime-400/10 font-bold text-lime-400`}>
      {label}
    </div>
  )
}
